var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.495076 10.3042C0.26764 10.4356 0.101695 10.6519 0.0337341 10.9056C-0.0342266 11.1593 0.00136305 11.4296 0.132676 11.6571L4.53428 19.2814C4.59932 19.3941 4.68592 19.4928 4.78913 19.572C4.89234 19.6511 5.01013 19.7092 5.13578 19.7429C5.26143 19.7765 5.39248 19.7851 5.52144 19.7681C5.6504 19.7511 5.77476 19.7089 5.8874 19.6438L23.5048 9.47262C23.6175 9.40757 23.7162 9.32097 23.7954 9.21776C23.8746 9.11456 23.9326 8.99677 23.9663 8.87112C24 8.74547 24.0085 8.61442 23.9915 8.48545C23.9745 8.35649 23.9323 8.23214 23.8672 8.1195L19.4656 0.495177C19.4006 0.382531 19.314 0.2838 19.2108 0.204622C19.1076 0.125445 18.9898 0.0673727 18.8641 0.0337203C18.7385 6.79779e-05 18.6074 -0.00850493 18.4785 0.00849137C18.3495 0.0254877 18.2252 0.0677203 18.1125 0.132777L0.495076 10.3042ZM2.34332 11.5244L18.2452 2.34342L21.6566 8.25222L20.5106 8.9139L19.2321 6.69894L18.3744 7.1943L19.6528 9.40902L18.3412 10.1665L17.0625 7.9515L16.2048 8.44686L17.4835 10.6616L16.1733 11.4181L14.8946 9.2031L14.0368 9.69846L15.3156 11.9132L14.004 12.6706L12.227 9.5931L11.3692 10.0882L13.1462 13.1657L11.8344 13.9232L10.5556 11.7082L9.69788 12.2036L10.9766 14.4183L9.66644 15.1745L8.38796 12.9598L7.5302 13.4552L8.80868 15.6699L7.49708 16.4271L6.21836 14.2124L5.3606 14.7077L6.63932 16.9225L5.75468 17.4332L2.34332 11.5244Z",
    fill: "url(#paint0_linear_937_7514)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_7514",
    x1: 24,
    y1: 19.7766,
    x2: 0.908993,
    y2: 9.49692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.7555675329185dfa896432f44dfa8c52.svg";
export { ForwardRef as ReactComponent };